import { render } from "./EnhancedTierBadge.vue?vue&type=template&id=6a5cb1b7&scoped=true"
import script from "./EnhancedTierBadge.vue?vue&type=script&lang=js"
export * from "./EnhancedTierBadge.vue?vue&type=script&lang=js"

import "./EnhancedTierBadge.vue?vue&type=style&index=0&id=6a5cb1b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a5cb1b7"]])

export default __exports__